import { type Provider, ProviderEnum } from '@dynamic-labs/sdk-api-core';

import { assertDefined } from '../../../../../../../utils/assertDefined';

/** Helper function to build the OAuth base URL for a given provider. */
export const getOAuthBaseUrl = (provider: Provider): URL => {
  assertDefined(provider.provider, 'Provider type not found');

  const providerType = provider.provider;

  if (providerType === ProviderEnum.Telegram) {
    assertDefined(
      provider.authorizationUrl,
      'Telegram authorization URL not found'
    );
    return new URL(provider.authorizationUrl);
  }

  assertDefined(provider.baseAuthUrl, 'Base auth URL not found');

  if (providerType === ProviderEnum.Shopify) {
    assertDefined(
      provider.shopifyStore,
      'Shopify store value not found in provider'
    );
    const loginBaseUrl = provider.baseAuthUrl.replace(
      '{{shopifyStore}}',
      provider.shopifyStore
    );
    return new URL(loginBaseUrl);
  }

  return new URL(provider.baseAuthUrl);
};
